import React from "react";

import "../../App.scss";

import { useNavigate } from "react-router-dom";

import { itx } from "../../translationItx/itx";
import { showErrToast, showToast } from "../Toasts";
import axios from "../../utils/axios";
import { stringToShortKey } from "../../models/utils";

export default function VerificationProjectCard(props: { setUserVerified: (show: boolean) => void }): JSX.Element {
  const { setUserVerified } = props;
  const navigate = useNavigate();
  const numberOfInputs = 4;

  function VerificationCodeInput(props: { numberOfInputs: number }) {
    const { numberOfInputs } = props;
    const inputs = new Array<any>();
    function CodeInpt(props: { count: number }) {
      return (
        <input
          id={"verificationNumber" + props.count}
          type="text"
          style={{
            width: "30px",
            height: "40px",
            fontSize: "20px",
            textAlign: "center",
            marginRight: "5px",
            borderRadius: "5px",
            border: "1px solid gray",
          }}
          maxLength={1}
          onPaste={(ev) => {
            // set here the pasted values in the different inputs
            const paste = ev.clipboardData.getData("text");

            for (let i = 1; i <= numberOfInputs; i++) {
              const element = document.getElementById("verificationNumber" + i);
              const char = paste.charAt(i - 1);
              if (element && char) {
                (element as HTMLInputElement).value = char;
              }
            }
          }}
          onChange={(ev) => {
            const value = ev.target.value;
            if (value && value.length == 1 && value !== "") {
              // focuse here the next input
              const nextInput = document.getElementById("verificationNumber" + (props.count + 1)) as HTMLInputElement;
              if (nextInput) {
                nextInput.focus();
              }
            }
          }}
          onKeyDown={(ev) => {
            // set old value to new value
            if (ev.target) {
              const isNumberOrINAlphabet = ev.key.match(/([0-9]|[a-z]|[A-Z])/) && ev.key.length === 1;
              if (ev.key === "Backspace") {
              } else if (isNumberOrINAlphabet && !ev.ctrlKey && ev.target instanceof HTMLInputElement) {
                ev.target.value = ev.key;
                const nextInput = document.getElementById("verificationNumber" + (props.count + 1)) as HTMLInputElement;
                if (nextInput) {
                  nextInput.focus();
                }
                ev.preventDefault();
                return;
              } else {
              }
            }
          }}
        />
      );
    }
    for (let i = 1; i <= (numberOfInputs || 4); i++) {
      inputs.push(<CodeInpt count={i} key={"codeInput" + i} />);
    }
    return <div style={{ padding: "10px" }}>{inputs}</div>;
  }
  function resendCode() {
    const possibleAnswersWithTranslations = new Map<string, { text: string; verified: boolean }>([
      [
        "Verification code has been sent to your email.", // no itx
        {
          text: itx(
            "verificationProjectCard.verificationCodeSent",
            "Der Verifizierungscode wurde an deine E-Mail gesendet.",
          ),
          verified: false,
        },
      ],
      [
        "Failed to send verification code", // no itx
        {
          text: itx(
            "verificationProjectCard.verificationCodeFailed",
            "Der Verifizierungscode konnte nicht gesendet werden",
          ),
          verified: false,
        },
      ],
      [
        "User is already verified", // no itx
        { text: itx("verificationProjectCard.userAlreadyVerified", "Du bist bereits verifiziert."), verified: true },
      ],
      [
        "Verification code resent successfully", // no itx
        {
          text: itx(
            "verificationProjectCard.codeResentSuccess",
            "Der Code wurde erfolgreich erneut an die hinterlegte E-Mail gesendet",
          ),
          verified: false,
        },
      ],
    ]);
    // here send the code again to the user email
    const payload = {
      userId: state.loggedInUser?.id,
      email: state.loggedInUser?.email,
      code: stringToShortKey(state.loggedInUser?.id || ""),
    };
    axios
      .post("/api/register/resendCode", payload)
      .then((response) => {
        console.log("Code resent response:", response.data);
        const key = response.data.MESSAGE || "";

        const text =
          possibleAnswersWithTranslations.get(key)?.text ||
          itx("verificationProjectCard.codeResent", "Der Code wurde erneut gesendet");
        showToast({ text });
        if (possibleAnswersWithTranslations.get(key)?.verified) {
          setUserVerified(true);
        }
      })
      .catch((error) => {
        console.error("Error resending code:", error);
        const key = error.data.MESSAGE || "";
        const text =
          possibleAnswersWithTranslations.get(key)?.text ||
          itx("verificationProjectCard.codeResentError", "Etwas ist schief gelaufen");
        showErrToast(text);
        if (possibleAnswersWithTranslations.get(key)?.verified) {
          setUserVerified(true);
        }
      });
  }
  /////////////////////////////////////////////////////////////////
  async function verifyCode() {
    const values: Array<string> = [];
    const possibleAnswersWithTranslations = new Map<string, { text: string; verified: boolean }>([
      [
        "Verification code not found or expired", // no itx
        {
          text: itx(
            "verificationProjectCard.codeIncorrect",
            "Der eingegebene Code wurde nicht gefunden oder ist abgelaufen. Bitte fordere einen neuen an.",
          ),
          verified: false,
        },
      ],
      [
        "Invalid verification code",
        { text: itx("verificationProjectCard.invalidCode", "Der eingegebene Code ist ungültig."), verified: false },
      ],
      [
        "User account verified successfully!", // no itx
        {
          text: itx("verificationProjectCard.codeVerified", "Dein Benutzerkonto wurde erfolgreich verifiziert!"),
          verified: true,
        },
      ],
      [
        "User is already verified", // no itx
        { text: itx("verificationProjectCard.userAlreadyVerified", "Du bist bereits verifiziert."), verified: true }, 
      ],
    ]);
    for (let i = 1; i <= numberOfInputs; i++) {
      const val = (document.getElementById("verificationNumber" + i) as HTMLInputElement)?.value;
      if (!val || val.length == 0) {
        break;
      }
      values.push(val);
    }

    if (values.length < numberOfInputs) {
      showErrToast(itx("verificationProjectCard.codeIncomplete", "Bitte geb den vollständigen 4-stelligen Code ein."));
      return;
    }

    const fullCode = values.join("");

    // here verify the code with the server

    axios
      .post("/api/register/activateUser", {
        userId: state.loggedInUser?.id,
        email: state.loggedInUser?.email,
        reqCode: fullCode,
      })
      .then((response) => {
        const key = response.data.MESSAGE || "";
        let text = possibleAnswersWithTranslations.get(key)?.text;
        if (text === undefined) {
          text =
            response.data.STATUS == "SUCCESS"
              ? itx("verificationProjectCard.emailVerified", "Deine E-Mail wurde verifiziert")
              : itx(
                  "verificationProjectCard.codeVerificationError",
                  "Fehler bei der Code-Überprüfung. Bitte versuche es erneut.",
                );
        }
        if (response.data.STATUS == "SUCCESS") {
          showToast({ text });
          // navigate to project selection
          state.navigate("/");
          setUserVerified(true);
        } else {
          showErrToast(text);
        }
      })
      .catch((error) => {
        const key = error.data.MESSAGE || "";
        const text =
          possibleAnswersWithTranslations.get(key)?.text ||
          itx("verificationProjectCard.codeServerError", "Es ist ein Fehler aufgetreten. Bitte versuche es erneut.");
        showErrToast(text);
        if (possibleAnswersWithTranslations.get(key)?.verified) {
          setUserVerified(true);
        }
        console.error("Error verifying code:", error);
      });
  }

  /////////////////////////////////////////////////////////////////

  return (
    <div
      id={"ExampleProjectCard"} // no itx
      key={"ExampleProjectCard"} // no itx
      className={"projectSelectionCard"}
      style={{ backgroundColor: "lightgray", border: "2px solid var(--primary-color)" }}
    >
      <div style={{ fontSize: "1.5em" }}>
        {itx("verificationProjectCard.verificationProject", "Bitte verifiziere deine E-Mail")}
      </div>
      <div style={{}}>
        {itx("verificationProjectCard.verificationProjectDescription", "4-stelligen Code eingeben:")}
      </div>
      <VerificationCodeInput numberOfInputs={numberOfInputs} />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <button className="button" style={{ backgroundColor: "var(--primary-color)" }} onClick={resendCode}>
          {itx("verificationProjectCard.resendCode", "Code erneut senden")}
        </button>
        <button className="button" style={{ backgroundColor: "var(--primary-color)" }} onClick={verifyCode}>
          {itx("verificationProjectCard.ok", "OK")}
        </button>
      </div>
    </div>
  );
}
